// extracted by mini-css-extract-plugin
export default {"paper":"ScheduleDetail_paper__kA6nK","key":"ScheduleDetail_key__NCuMU","value":"ScheduleDetail_value__KuNss","deleteIcon":"ScheduleDetail_deleteIcon__zyCWC"};